<template>
  <div>
    <b-card no-body class="mt-3" type="dark" bg-variant="light">
      <b-col class="ml--2">
        <h3 class="mt-1 ml-1">Rezeptmanagment</h3>
      </b-col>
    </b-card>
    <StempelCard />
    <!-- Connect Connect Hinweg -->
    <InputCardConnect
      :connect="useConnect"
      :input="{
        headline: 'Connect Hinweg',
        vuexModule: 'Rezeptmanagment',

        row1: {
          text: 'AT',
          icon: 'clock-history',

          value: 'Rezeptmanagment/connectHinwegAt'
        },
        row2: {
          text: 'Stunden pro Tag',
          icon: 'clock',
          value: 'Rezeptmanagment/connectHinwegStundenProTag'
        },
        row3: {
          text: 'Stunden pro Monat',
          disabledCheck: true,
          icon: 'clock',
          value: 'Rezeptmanagment/connectHinwegStundenMonat',
          mutationName: ''
        },
        row4: {
          text: 'Belege pro Stunde',
          icon: 'files',
          value: 'Rezeptmanagment/connectHinwegBelegeProStunde',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Monat',
          icon: 'cash-stack',
          value: 'Rezeptmanagment/connectHinwegKostenProMonat'
        },
        row6: {
          text: 'Kosten pro Beleg',
          icon: 'cash',
          value: 'Rezeptmanagment/connectHinwegKostenProBeleg'
        }
      }"
    />

    <!-- Connect Connect Rückweg -->
    <InputCardConnect
      :connect="connectMitExport"
      :input="{
        headline: 'Connect inkl. Rückweg',
        vuexModule: 'Rezeptmanagment',

        row1: {
          text: 'AT',
          icon: 'clock-history',
          value: 'Rezeptmanagment/connectRueckwegAt'
        },
        row2: {
          text: 'Stunden pro Tag',
          icon: 'clock',
          value: 'Rezeptmanagment/connectRueckwegStundenProTag'
        },
        row3: {
          text: 'Stunden pro Monat',
          disabledCheck: true,
          icon: 'clock',
          value: 'Rezeptmanagment/connectRueckwegStundenMonat',
          mutationName: ''
        },
        row4: {
          text: 'Belege pro Stunde',
          icon: 'files',
          value: 'Rezeptmanagment/connectRueckwegBelegeProStunde',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Monat',
          icon: 'cash-stack',
          value: 'Rezeptmanagment/connectRueckwegKostenProMonat'
        },
        row6: {
          text: 'Kosten pro Beleg',
          icon: 'cash',
          value: 'Rezeptmanagment/connectRueckwegKostenProBeleg'
        }
      }"
    />

    <!-- Connect Rückweg ohne Datenexport -->
    <InputCardConnect
      :connect="connectOhneExport"
      :input="{
        headline: 'Connect Rückweg exkl. Datenexport',
        vuexModule: 'Rezeptmanagment',

        row1: {
          text: 'AT',
          icon: 'clock-history',
          value: 'Rezeptmanagment/connectRueckwegOhneDatenexportAt'
        },
        row2: {
          text: 'Stunden pro Tag',
          icon: 'clock',
          value: 'Rezeptmanagment/connectRueckwegOhneDatenexportStundenProTag'
        },
        row3: {
          text: 'Stunden pro Monat',
          disabledCheck: true,
          icon: 'clock',
          value: 'Rezeptmanagment/connectRueckwegOhneDatenexportStundenMonat',
          mutationName: ''
        },
        row4: {
          text: 'Belege pro Stunde',
          icon: 'files',
          value:
            'Rezeptmanagment/connectRueckwegOhneDatenexportBelegeProStunde',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Monat',
          icon: 'cash-stack',
          value: 'Rezeptmanagment/connectRueckwegOhneDatenexportKostenProMonat'
        },
        row6: {
          text: 'Kosten pro Beleg',
          icon: 'cash',
          value: 'Rezeptmanagment/connectRueckwegOhneDatenexportKostenProBeleg'
        }
      }"
    />
    <div class="mt-3">
      Im Ergebnis wird zur Zeit Connect nicht berücksichtigt!
    </div>
  </div>
</template>

<script>
import InputCardConnect from "@/components/InputCardConnect.vue";
import StempelCard from "@/components/StempelCard.vue";
export default {
  name: "Rezeptmanagment",
  components: {
    InputCardConnect,
    StempelCard
  },
  computed: {
    useConnect() {
      return !this.$store.state.Gebuehren.useConnect;
    },
    connectMitExport() {
      if (this.useConnect) {
        return true;
      } else {
        return this.$store.state.Gebuehren.connectMitExport;
      }
    },
    connectOhneExport() {
      if (this.useConnect) {
        return true;
      } else {
        return !this.$store.state.Gebuehren.connectMitExport;
      }
    }
  }
};
</script>
